import { API } from 'aws-amplify'

import * as actionTypes from './actionTypes';

const basePath = '/duplicates';
const apiName = 'duplicates';
const actions = {
  getDuplicate: async ({ commit }, payload) => {
    commit(actionTypes.GET_DUPLICATE_START);
    const path = `${basePath}/${payload}`;
    const opts = {};
    try {
      const res = await API.get(apiName, path, opts);
      console.log('Get DUPLICATE - res: ', res);
      commit(actionTypes.GET_DUPLICATE_SUCCESS, res);
    } catch (err) {
      console.log('Err getting duplicate: ', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.GET_DUPLICATE_FAIL, errorMsg);
    }
  },
  getDuplicateInfo: async ({ commit }, payload) => {
    commit(actionTypes.GET_DUPLICATE_INFO_START);
    const path = `${basePath}/info`;
    const opts = {
      body: payload,
    };
    try {
      const res = await API.post(apiName, path, opts);
      console.log('Get DUPLICATE Info - res: ', res);
      commit(actionTypes.GET_DUPLICATE_INFO_SUCCESS, res);
    } catch (err) {
      console.log('Err getting duplicate: ', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.GET_DUPLICATE_INFO_FAIL, errorMsg);
    }
  },
  listDuplicates: async ({ commit }) => {
    commit(actionTypes.LIST_DUPLICATES_START);
    const path = `${basePath}/all`;
    try {
      const res = await API.get(apiName, path, {});
      console.log('List Duplicates res: ', res);
      commit(actionTypes.LIST_DUPLICATES_SUCCESS, res);
    } catch (err) {
      console.log('List Duplicates Error: ', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.LIST_DUPLICATES_FAIL, errorMsg);
    }
  },
  updateDuplicate: async ({ commit, state }, payload) => {
    commit(actionTypes.UPDATE_DUPLICATE_START);
    const { vm, duplicate } = payload;
    const opts = {
      body: {
        isResolved: duplicate.isResolved,
        resolvedBy: state.user.username
      },
    };
    const path = `${basePath}/${duplicate.id}`;
    try {
      const res = await API.put(apiName, path, opts);
      console.log('Update DUPLICATE - res: ', res);
      commit(actionTypes.UPDATE_DUPLICATE_SUCCESS, res);
      vm.$store.dispatch('listRecipients');
    } catch (err) {
      console.log('Duplicate Update Error: ', err);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.UPDATE_DUPLICATE_FAIL, errorMsg);
    }
  },
  setDuplicateToResolve: ({ commit }, payload) => {
    commit(actionTypes.SET_DUPLICATE_TO_RESOLVE, payload);
  },
  clearDuplicateState: ({ commit }) => {
    commit(actionTypes.CLEAR_DUPLICATE_UPDATE_STATE);
  }
};

export default actions;
